import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchChargeTypes,
  createChargeType,
  updateChargeType,
  deleteChargeType,
  type ListChargeTypesQuery,
  type CreateChargeTypePayload,
  type UpdateChargeTypePayload,
} from '@/services/api/chargeTypes.api';

export function useChargeTypes(query: ListChargeTypesQuery, enabled = true) {
  return useQuery({
    queryKey: ['charge-types', query],
    queryFn: () => fetchChargeTypes(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useCreateChargeType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateChargeTypePayload) => createChargeType(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['charge-types'] });
    },
  });
}

export function useUpdateChargeType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateChargeTypePayload }) =>
      updateChargeType(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['charge-types'] });
    },
  });
}

export function useDeleteChargeType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteChargeType(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['charge-types'] });
    },
  });
}
